import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=10dcb104"
import script from "./ActionDialog.vue?vue&type=script&lang=js"
export * from "./ActionDialog.vue?vue&type=script&lang=js"
import style0 from "./ActionDialog.vue?vue&type=style&index=0&id=10dcb104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports